import { ThemeEvents } from '@theme/events';
import { IntelligemsDomEvents, dispatchIntelligemsEvent } from '@theme/intelligems-events';

class ProductMediaGallery extends HTMLElement {
  #mainSlider = null;

  connectedCallback() {
    this.addEventListener('click', this.#onArrowClick);
    this.#bindDragTracking();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onArrowClick);
    this.#unbindDragTracking();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  #onArrowClick = (event) => {
    if (!event.target.closest('.product-media-gallery-main-slider .splide__arrow')) return;
    this.#dispatchNavigateEvent('arrow');
  };

  #bindDragTracking = (attempts = 0) => {
    const sliderComponent = this.querySelector('slider-component');
    if (!sliderComponent?.slider) {
      if (attempts < 60) requestAnimationFrame(() => this.#bindDragTracking(attempts + 1));
      return;
    }

    this.#unbindDragTracking();
    this.#mainSlider = sliderComponent.slider;
    this.#mainSlider.on('dragged', this.#onDragged);
  };

  #unbindDragTracking = () => {
    this.#mainSlider?.off?.('dragged', this.#onDragged);
    this.#mainSlider = null;
  };

  #onDragged = () => {
    this.#dispatchNavigateEvent('drag');
  };

  #dispatchNavigateEvent = (source) => {
    dispatchIntelligemsEvent(this, IntelligemsDomEvents.productCarouselNavigate, { source });
  };

  updateMediaGallery = (event) => {
    if (event.detail?.data?.skipMediaRefresh) return;

    if (this.closest('.product-featured-section')) return;

    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(document.importNode(newMediaGallery, true));
      this.#bindDragTracking();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
